<div class="w-450px">
    <iui-messages id="message" #message class="ms-auto me-auto"></iui-messages>
</div>

<div>
    <div class="row">
        <div class="col-12" *ngIf="userProfile.accountId">
           
            <div class="row ms-1 mb-2">
                <span class="ps-0 col-4 fw-bold">Account ID: {{ userProfile.accountId }}</span>
                <div class="col-8 fw-bold truncate" [pTooltip]="userProfile.company" tooltipPosition="top"
                    appShowToolTipIfTruncated>Organization Name: {{ userProfile.company }}</div>
            </div>
            <div class="row ms-1 mb-2">
                <span class="ps-0 col-4 fw-bold">User ID: {{ userProfile.userName }}</span>
                <span class="col-4 fw-bold">Role: {{roleLabels}}</span>
            </div>
        </div>
        <div class="col-8">
            <form #myProfileForm="ngForm" (keydown.enter)="handleEnter($event)" name="myProfileForm" *ngIf="userProfile.accountId" (ngSubmit)="submit()">
                <div class="row ms-1 mb-2">
                    <button (click)="copyAccountInfo()" class="col-auto btn mt-2 mb-2 btn-primary" id="copyAccountInfo"
                        type="button">Copy Address Information from Account</button>
                </div>
                <div class="row">
                    <div class="col-4 mb-3">
                        <label for="firstName" class="required">First Name</label>
                        <input appScrText [(ngModel)]="userProfile.firstName" name="firstName" placeholder="First Name"
                            id="firstName" required maxlength="{{MaxLen.FirstName}}" appFirstNameValidator
                            #firstName="ngModel" />
                        <app-error-msg [field]="firstName" [fieldLabel]="'First Name'"
                            [form]="myProfileForm"></app-error-msg>
                    </div>
                    <div class="col-4 offset-2 mb-3">
                        <label for="lastName" class="required">Last Name</label>
                        <input appScrText [(ngModel)]="userProfile.lastName" name="lastName" placeholder="Last Name"
                            id="lastName" required maxlength="{{MaxLen.LastName}}" appLastNameValidator
                            #lastName="ngModel" />
                        <app-error-msg [field]="lastName" [fieldLabel]="'Last Name'"
                            [form]="myProfileForm"></app-error-msg>
                    </div>
                </div>
                <div class="row">

                    <div class="col-4 mb-3">
                        <label for="phoneInput" class="required">Phone Number</label>
                        <app-phone [(ngModel)]="userProfile.phone" #phone="ngModel" class="col-12" required name="phone" id="phone"></app-phone>
                        <app-error-msg [field]="phone" [fieldLabel]="'Phone Number'"
                            [form]="myProfileForm"></app-error-msg>
                    </div>
                    <div class="col-auto mb-3">
                        <label for="phoneExtension">Extension</label>
                        <input appScrText [(ngModel)]="userProfile.phoneExtension" size="8" name="phoneExtension"
                            id="phoneExtension" maxlength="{{MaxLen.PhoneExtension}}" />
                    </div>

                </div>
                <div class="row">

                    <div class="col-5 mb-3">
                        <label for="email" class="required">Email</label>
                        <input appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" #email="ngModel" appEmail [(ngModel)]="userProfile.email" name="email"
                            placeholder="Email" id="email" required maxlength="{{MaxLen.Email}}" size="30" />
                        <app-error-msg [field]="email" [fieldLabel]="'Email'" [form]="myProfileForm"></app-error-msg>
                    </div>
                    <div class="col-5 offset-1 mb-3">
                        <label for="confirmEmail" id="confirmEmailLabel"
                            [ngClass]="{required: myProfileForm?.controls?.email?.dirty}">Confirm
                            Email Address</label>
                        <input appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" #confirmEmail="ngModel" class="form-text form-control"
                            [(ngModel)]="userProfile.confirmEmail" name="confirmEmail"
                            placeholder="Confirm Email Address" id="confirmEmail"
                            [required]="myProfileForm?.controls?.email?.dirty === true" maxlength="{{MaxLen.Email}}" />
                        <app-error-msg [field]="confirmEmail" [fieldLabel]="'Confirm Email Address'"
                            [form]="myProfileForm">
                        </app-error-msg>
                        <div>
                            <span class="inline-error-text"
                                *ngIf="((userProfile.email !== userProfile.confirmEmail) && myProfileForm?.controls?.email?.dirty && myProfileForm.submitted && userProfile.confirmEmail !== undefined)">
                                Confirm Email Address must match Email
                            </span>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mb-3">
                        <label for="country" class="required">Country</label>
                        <app-country-dropdown [(ngModel)]="userProfile.country" name="country" #country="ngModel"
                            id="country">
                        </app-country-dropdown>
                        <app-error-msg [form]="myProfileForm" [field]="country" fieldLabel="Country"></app-error-msg>
                    </div>
                </div>
                <div class="row">
                    <div class="col-11 mb-3">
                        <label for="companyAddress1" class="required">Organization Address 1</label>
                        <input appScrText [(ngModel)]="userProfile.address1" name="companyAddress1"
                            placeholder="Organization Address 1" id="companyAddress1" required maxlength="{{MaxLen.Address}}"
                            #companyAddress1="ngModel" />
                        <app-error-msg [field]="companyAddress1" [fieldLabel]="'Organization Address 1'"
                            [form]="myProfileForm">
                        </app-error-msg>
                    </div>
                </div>
                <div class="row">
                    <div class="col-11 mb-3">
                        <label for="companyAddress2">Organization Address 2</label>
                        <input appScrText [(ngModel)]="userProfile.address2" name="address2"
                            placeholder="Organization Address 2" id="companyAddress2" maxlength="{{MaxLen.Address}}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mb-3">
                        <label for="city" class="required">City</label>
                        <input appScrText [(ngModel)]="userProfile.city" name="city" placeholder="City" id="city"
                            required maxlength="{{MaxLen.City}}" #city="ngModel" />
                        <app-error-msg [field]="city" [fieldLabel]="'City'" [form]="myProfileForm"></app-error-msg>
                    </div>
                    <div class="col-4 mb-3">
                        <label for="state"
                            [ngClass]="{required: userProfile.country === 'us' || userProfile.country === 'ca' }">State/Province</label>
                        <app-region-dropdown id="state" [(ngModel)]="userProfile.state" [country]="userProfile.country"
                            name="state"></app-region-dropdown>
                        <ng-container
                            *ngIf="myProfileForm.form.controls.state?.errors?.required && myProfileForm.submitted">
                            <span class="inline-error-text">State/Province is required.</span>
                        </ng-container>
                    </div>
                    <div class="col-3 mb-3">
                        <label for="zipInput"
                            [ngClass]="{required: userProfile.country === 'us' || userProfile.country === 'ca'}">Zip/Postal
                            Code</label>
                        <app-zipcode-input id="zip" name="zip" inputId="zipInput" [(ngModel)]="userProfile.zip"
                            [country]="userProfile.country" #zip="ngModel"></app-zipcode-input>
                        <app-error-msg [field]="zip" [fieldLabel]="'Zip/Postal Code'"
                            [form]="myProfileForm"></app-error-msg>
                    </div>
                </div>

                <h5>Email Subscriptions</h5>
                <div class="mb-2">Select your email message category subscriptions:</div>
                <div *ngFor="let category of emailCategories">
                    <p-checkbox value="{{category.name}}" [(ngModel)]="emailCategoryArray" name="{{category.name}}"
                        inputId="{{category.name}}" label="{{ category.description }}"></p-checkbox>
                </div>

                <div *ngIf="adminInfo" class="row mt-4">
                    <div class="col-9">
                        <h5>Account Administrators</h5>
                        <p><small>For assistance with your access to this account, please contact your account
                                administrator. For your account, the contact information is as follows:</small></p>
                        <p-table styleClass="p-datatable-striped" [columns]="tableColumn" [value]="adminInfo">
                            <ng-template pTemplate="header" let-columns>
                                <tr *ngIf="adminInfo.length > 0">
                                    <th [style.width.%]="col.width" *ngFor="let col of columns" class="noBorder">
                                        {{col.header}}
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                                <tr>
                                    <td><div>{{rowData.name}}</div></td>
                                    <td><div>{{rowData.phone | phoneNumber }}</div></td>
                                    <td><div class="ellipsis" [pTooltip]="rowData.email">{{rowData.email}}</div></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <div class="row ms-1 mt-3">
                    <button class="col-auto btn mt-2 mb-2 btn-primary" id="updateBtn" type="submit">
                        Update
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>